import React from "react";
import api from "../../../api";
import {getProductCategoryHints} from "../../../utils";
import {buildSearchFilter} from "../../../utils/build-search-filter";

const SEARCH_FIELDS = ["id", "name", "external_guid"]

export function useGetData() {
    const [dataItems, setDataItems] = React.useState([])
    const [isLoading, setIsLoading] = React.useState(false)
    const [pagination, setPagination] = React.useState(null)
    const [appliedFilters, setAppliedFilters] = React.useState("")

    const [categoryOptions, setCategoryOptions] = React.useState([])
    const [productCategoryOptions, setProductCategoryOptions] = React.useState([])
    const [badgeOptions, setBadgeOptions] = React.useState([])

    React.useEffect(() => {
        getItems()
        getCategoryOptions()
        getProductCategoryOptions()
        getBadgeOptions()
    }, [])

    async function getItems(page = 1, countOnPage = 20, filters = "") {
        setIsLoading(true)
        try {
            const { data } = await api.get(`product-set?page=${page}&countOnPage=${countOnPage}${filters}`)
            setPagination({
                current: data.pagination.currentPage,
                pageSize: data.pagination.countOnPage,
                total: data.pagination.total,
            })
            setDataItems(data?.items ?? [])
        } catch (error) {
            console.warn("Ошибка загрузки продуктовых наборов")
        } finally {
            setIsLoading(false)
        }
    }

    async function getCategoryOptions() {
        try {
            const { data } = await api.get("virtual-product-categories?page=1&countOnPage=200")
            setCategoryOptions(data.items)
        } catch (e) {
            console.warn("Ошибка загрузки категорий")
        }
    }

    async function getBadgeOptions() {
        try {
            const { data } = await api.get("product-labels", {useV2Api: true})
            const formattedOptions = data.items.map((item) => ({
                value: item.id,
                label: item.name.find((el) => el.language === "ru")?.content ?? "Нет названия"
            }))
            setBadgeOptions(formattedOptions)
        } catch (e) {
            console.warn("Ошибка загрузки лейблов")
        }
    }

    async function getProductCategoryOptions() {
        try {
            const data = await getProductCategoryHints();

            const options = data.reduce((acc, item) => {
                return [
                    ...acc,
                    {
                        label: item.name,
                        value: item.id,
                    },
                ];
            }, []);
            setProductCategoryOptions(options);
        } catch (e) {
            console.warn("Ошибка загрузки категорий")
        }
    }

    function handleTableChange(pagination) {
        getItems(pagination.current, pagination.pageSize, appliedFilters)
    }

    function handleSearchTable(value) {
        const filters = buildSearchFilter(value, SEARCH_FIELDS)
        setAppliedFilters(filters)
        getItems(1, 20, filters)
    }

    function getFormattedItems (items) {
        return items.map((item) => {
            const nameRu = item.name.find((name) => name.language === "ru")?.content ?? ""
            const productCategories = item.dashboardProductCategories.map((productCategory) => {
                return productCategory.name.find((name) => name.language === "ru")?.content ?? ""
            })

            const vCategories = item.dashboardProductVirtualCategories.map((vCategory) => {
                return vCategory.name.find((name) => name.language === "ru")?.content ?? ""
            })

            return {
                ...item,
                key: item.id,
                nameRu,
                productCategories,
                vCategories,
            }
        })
    }

    return {
        dataItems,
        pagination,
        isLoading,
        handleTableChange,
        handleSearchTable,
        getFormattedItems,
        refetch: () => getItems(pagination?.current || 1, pagination?.pageSize || 20, appliedFilters),
        options: { categoryOptions, productCategoryOptions, badgeOptions },
    }
}